import { Box, Button, Grid, IconButton, Paper, TextField, Typography, makeStyles } from '@material-ui/core'
import React from 'react'
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { Autocomplete } from '@material-ui/lab';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import RemoveIcon from '@material-ui/icons/Remove';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { deepAnaliticsSelector, loadingChartDeepAnalitics, setDataLocal } from '../../redux/reducers/chart-deep-analitics';


const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 2,
        width: '100%',
        minHeight: '100px',
    },
    item: {
        padding: theme.spacing(2),
        display: 'flex',
        alignItems:'center',
        columnGap: '20px',
    },
    icon: {
        width: '40px',
        height: '40px'
    },
    button: {
        color: 'green',
        height: '44px',
        // width: '100%',
        fontSize: 'calc(0.7vw + 4px)',
    },
    iconButton: {
        color: 'black',
        width: '40px',
        height: '40px'
    }
}))

const translate = {
    month: 'Месяц',
    week: 'Неделя'
}

const interval = [
    'month',
    'week',
]

const formikInitialValues = {
    startTime: new Date("2022-10-01"),
    endTime: new Date("2023-10-25"),
    interval: interval[0],
}

const formikValidationSchema = Yup.object({
    startTime: Yup.date().max(new Date(), 'Нельзя заглянуть в будущее').required('Введите корректную дату'),
    endTime: Yup.date().max(new Date(), 'Нельзя заглянуть в будущее').required('Введите корректную дату'),
    interval: Yup.string().required('Введите интервал'),
  })

const crateDayMonths = (number, months) => {
    const reName = months ? number + 1 : number
    if (reName > 9) {
        return reName
    } else {
        return `0${reName}`
    }
}

export const GroupButtonChart = () => {

    const {
        touched,
        values,
        errors,
        getFieldProps,
        setFieldValue,
        setFieldTouched,
        resetForm,
        setTouched,
        setErrors,
        validateForm
    } = useFormik({
        initialValues: formikInitialValues,
        validationSchema: formikValidationSchema
    })
    
    const location = useLocation()
    const dispatch = useDispatch()
    const classes = useStyles()
    const history = useHistory()

    const {loading} = useSelector(deepAnaliticsSelector)

    const handleClick = () => {
        if (JSON.stringify(errors) === '{}') {
            const name = location.pathname.split('/').at(-1)
            dispatch(loadingChartDeepAnalitics({
                name: name,
                startTime: `${values.startTime.getFullYear()}-${crateDayMonths(values.startTime.getMonth(), true)}-${crateDayMonths(values.startTime.getDate(), false)}`,
                endTime: `${values.endTime.getFullYear()}-${crateDayMonths(values.endTime.getMonth(), true)}-${crateDayMonths(values.endTime.getDate(), false)}`, 
                localCompany: localStorage.getItem('companies'),
                contractName: localStorage.getItem('contractName'),
                interval: `${values.interval}`,
            }))
        }
    }


    return (
        <Paper className={classes.root} elevation={2}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Grid container spacing={2} alignItems='center'>
                    <Grid item xs={1}>
                        <Box className={classes.item}>
                            <IconButton
                                className={classes.iconButton}
                                onClick={() =>{dispatch(setDataLocal([])); history.goBack()}}
                            >
                                <KeyboardBackspaceIcon className={classes.icon}/>
                            </IconButton>
                        </Box>
                    </Grid>
                    <Grid item xs={4}>
                        <Box className={classes.item}>
                            <KeyboardDatePicker
                                id="startTime"
                                label="Начало"
                                format="yyyy/MM/dd"
                                value={values.startTime}
                                onChange={(date) => setFieldValue('startTime', date)}
                                KeyboardButtonProps={{
                                    'aria-label': 'change date',
                                }}
                                error={errors.startTime}
                            />
                            <RemoveIcon className={classes.icon}/>
                            <KeyboardDatePicker
                                id="endTime"
                                label="Конец"
                                format="yyyy/MM/dd"
                                value={values.endTime}
                                onChange={(date) => setFieldValue('endTime', date)}
                                KeyboardButtonProps={{
                                    'aria-label': 'change date',
                                }}
                                error={errors.endTime}
                            />
                        </Box>                     
                    </Grid>
                    <Grid item xs={3}>
                        <Box className={classes.item}>
                            <Autocomplete 
                                id='interval'
                                value={values.interval}
                                options={interval}
                                onChange={(_, value) => setFieldValue('interval', value )}
                                getOptionLabel={(option) => translate[option]}
                                style={{ width: '30%' }}
                                renderInput={(params) => <TextField {...params} label="Интервал" error={errors.interval} />}
                            />
                            <Button
                                className={classes.button}
                                variant="outlined"
                                onClick={handleClick}
                                disabled={loading}
                                // style = {{width: '30%'}}
                            >
                                Рассчитать
                            </Button>
                        </Box>
                    </Grid>
                    <Grid item xs={2} style={{display: 'flex', alignItems:'center'}}>
                        <Typography variant='h4'>
                            Бригада: {location.pathname.split('/').at(-1)}
                        </Typography>
                    </Grid>
                    <Grid item xs={2} style={{display: 'flex', alignItems:'center'}}>
                        <Box style={{display: 'flex', flexDirection: 'column'}}>
                            <Typography variant='h6'>
                                {localStorage.getItem('companies')}
                            </Typography>
                            <Typography variant='h6'>
                                {localStorage.getItem('contractName')}
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
            </MuiPickersUtilsProvider>
        </Paper> 
    )
}
